import React from "react";
import { ExtendedTypography } from "@vapor/react-extended/ExtendedTypography";
import { faUser } from "@fortawesome/pro-regular-svg-icons";
import Button from "@vapor/react-material/Button";
import { VaporIcon } from "@vapor/react-icons";
import Drawer from "@vapor/react-material/Drawer";
import Box from "@vapor/react-material/Box";
import IconButton from "@vapor/react-material/IconButton";
import Close from "@mui/icons-material/Close";
import UserCard from "./UserCard.tsx";
import { UnderlinedBox } from "../../re-usable-components/UnderlinedBox.tsx";
import { LanguageAndFormatForm } from "./LanguageAndFormatForm.tsx";
import { UserData } from "../../../assets/DummyData.tsx";
import { useDrawerStore } from "../../../context/DrawerContext/index.ts";
import { UserAgent } from "../types.ts";

interface UserProps {
  user: UserAgent;
  drawerName: string | null;
}

export const UserDetails: React.FC<UserProps> = ({ drawerName }) => {
  const { open, setOpen } = useDrawerStore();

  const handleDrawer = () => {
    setOpen(open === drawerName ? null : drawerName);
    if (!open) {
      const activeElement = document.activeElement as HTMLElement;
      activeElement.blur();
    }
  };
  return (
    <Box sx={{ display: "flex", position: "relative", m: 1 }}>
      <Button
        sx={{
          backgroundColor: open === drawerName ? "#008FD6" : "none",
          "&:hover": {
            backgroundColor: "#008FD6",
          },
        }}
        onClick={handleDrawer}
      >
        <VaporIcon icon={faUser} color="inverse" size="20px" />
      </Button>
      <Drawer
        anchor="right"
        open={open == drawerName}
        onClose={handleDrawer}
        // hideBackdrop
        width={620}
      >
        <UnderlinedBox>
          <ExtendedTypography
            variant="titleSmall"
            color="primary.main"
            component="div"
            sx={{ marginLeft: 2 }}
          >
            Profilo Utente
          </ExtendedTypography>
          <IconButton onClick={handleDrawer} color="primary">
            <Close />
          </IconButton>
        </UnderlinedBox>

        <Box sx={{ marginLeft: 2.4 }}>
          <UserCard user={UserData} />
        </Box>
        <LanguageAndFormatForm
          language={UserData.language}
          format={UserData.region_format}
          handleClose={handleDrawer}
        />
      </Drawer>
    </Box>
  );
};
